module.exports = __webpack_public_path__ + "img/bronce2.c95ca676.png";